module.exports = __webpack_public_path__ + "img/cuff buttons quantity.fd95f3f6.png";